import { render, staticRenderFns } from "./singleBillReport.vue?vue&type=template&id=482a25f2&scoped=true"
import script from "./singleBillReport.vue?vue&type=script&lang=js"
export * from "./singleBillReport.vue?vue&type=script&lang=js"
import style0 from "./singleBillReport.vue?vue&type=style&index=0&id=482a25f2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482a25f2",
  null
  
)

export default component.exports